import { ColorsDescriptor } from 'chartjs-plugin-autocolors';
import { Moment } from 'moment';

import { GetJobsiteWorkerDashboardQuery } from 'apollo/generated/client-operations';

import { PageSearchParams } from 'utils';

export type WorkerDashboardData =
  GetJobsiteWorkerDashboardQuery['getJobsiteWorkerDashboard'];
export type WorkerSession = WorkerDashboardData['results'][number];

export type DashboardFilters = Pick<
  Required<PageSearchParams>,
  | 'developerIds'
  | 'jobsiteIds'
  | 'contractor'
  | 'trade'
  | 'jobTitle'
  | 'compliant'
  | 'overnight'
> &
  Pick<PageSearchParams, 'currentlyOnsite'> & {
    dateRange: {
      startDate: Moment;
      endDate: Moment;
    };
    today: never;
  };

export type OdinChartColorDescriptor = ColorsDescriptor & {
  backgroundRgb: string;
};

const hexToRgb = (hex: string): string => {
  const value = parseInt(hex.replace('#', ''), 16);
  // eslint-disable-next-line no-bitwise
  return `${(value >> 16) & 255}, ${(value >> 8) & 255}, ${value & 255}`;
};

const chartColor = (
  background: string,
  border: string,
): OdinChartColorDescriptor => ({
  background,
  backgroundRgb: hexToRgb(background),
  border,
});

// these are the current Odin defined chart colors
export const odinChartColors: OdinChartColorDescriptor[] = [
  chartColor('#5F1F8A', 'white'),
  chartColor('#3048CD', 'white'),
  chartColor('#00884D', 'white'),
  chartColor('#A370E6', 'white'),
  chartColor('#6A8FFF', 'white'),
  chartColor('#00C673', 'white'),
  chartColor('#FFA995', 'white'),
  chartColor('#F5C23E', 'white'),
  chartColor('#D6C9F5', '#001024'),
  chartColor('#CBDBFF', '#001024'),
  chartColor('#BDF4DC', '#001024'),
  chartColor('#BEC9D5', '#001024'),
];
